<script setup>
import { Toaster } from '@/components/ui/sonner'
import 'vue-sonner/style.css'
</script>
<template>
  <Toaster class="pointer-events-auto" rich-colors position="top-right" />
  <router-view />
</template>
